import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { getComplianceTarget, saveComplianceTarget } from "./systemSettingsService";
import { ChevronDown } from 'lucide-react';



export default function ComplianceTargetSection() {

  const { setPopup } = useContext(PopupContext);
  const [complianceTarget, setComplianceTarget] = useState('0');
  const [collapsed, setCollapsed] = useState(true);

  // const setTarget = false;
  const isStartDisabled = false;

  const fetchData = async () => {
    try {
      const targetData = await getComplianceTarget();
      setComplianceTarget(targetData.value);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetComplianceTargetClick = event => {
    showInfoToast('Setting Compliance Target', 'Compliance Target');
    // setTarget(true);

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Complaince Target',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      await saveComplianceTarget(complianceTarget);
    };
  };

  const changeComplianceTarget = (value) => { setComplianceTarget(value); }

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Compliance Target</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <p className="oct_settings-description">
          Compliance Target which is displayed on the Compliance % chart at the Dashboard.
        </p>

        <div className="oct_settings-form-grid">
          <div className="oct_settings-field">
            <label className="oct_settings-label">Compliance Target</label>
            <input
              className="oct_settings-input-v2"
              type="number"
              value={complianceTarget}
              onChange={event => changeComplianceTarget(event.target.value)}
            />
          </div>
          <div className="oct_settings-field">
            <label className="oct_settings-label">Unit</label>
            <select className="oct_select-v2" disabled>
              <option value="Percentage">Percentage</option>
            </select>
          </div>
        </div>

        <button
          className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
          onClick={onSetComplianceTargetClick}
        >
          Save Compliance Target
        </button>
      </div>
    </>
  );
}